import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.quadroo.com.br',
});

export default api;
